var moduleMap = {
	"./elc-ramp": () => {
		return __webpack_require__.e(/* elc-ramp */ "elc-ramp").then(() => (() => ((__webpack_require__("./src/exported/ramp/index.ts")))));
	},
	"./ramp-social-profile": () => {
		return __webpack_require__.e(/* ramp-social-profile */ "ramp-social-profile").then(() => (() => ((__webpack_require__("./src/exported/ramp-social-profile/index.ts")))));
	},
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("vendors-node_modules_estee_elc-form_src_store_FormStore_ts-node_modules_estee_elc-form_src_st-348667"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});